/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Deleteconfirm2Inputs */

const zh_organizationsettings_deleteconfirm2 = /** @type {(inputs: Organizationsettings_Deleteconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除`)
};

const en_organizationsettings_deleteconfirm2 = /** @type {(inputs: Organizationsettings_Deleteconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const es_organizationsettings_deleteconfirm2 = /** @type {(inputs: Organizationsettings_Deleteconfirm2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Organizationsettings_Deleteconfirm2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_deleteconfirm2 = /** @type {((inputs?: Organizationsettings_Deleteconfirm2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Deleteconfirm2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_deleteconfirm2(inputs)
	if (locale === "en") return en_organizationsettings_deleteconfirm2(inputs)
	return es_organizationsettings_deleteconfirm2(inputs)
});
export { organizationsettings_deleteconfirm2 as "organizationSettings_deleteConfirm" }